import React from 'react';

import Tooltip from './Tooltip';
import { notEmpty } from '../shared/Util';
import { tooltip as tooltipProps } from './shared/PropTypes';

const FormLabel = ({
  children = [],
  htmlFor,
  klass = null,
  label,
  mobileSubLabel = null,
  required = false,
  spanKlass = '',
  tooltip = null,
}) => (
  <label htmlFor={htmlFor} className={klass}>
    {
      label.length > 0 && (
        <span className={spanKlass ? `label-text ${spanKlass}` : 'label-text'}>
          {label}
          {required && <span className="required">*</span>}
          {tooltip && <Tooltip tip={tooltip} />}
          {notEmpty(mobileSubLabel) && <div className="sub-label">{mobileSubLabel}</div>}
        </span>
      )
    }
    {children}
  </label>
);

FormLabel.propTypes = tooltipProps.props;

export default FormLabel;
